import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import {changeSystem} from '../../actions/action_changeSystem';
import { Collapse } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';

import HeaderLinks from '../../components/Header/HeaderLinks.jsx';
import image from '../../assets/img/full-screen-image-3.jpg';

import routesForUser from '../../utils/routesForUser';
import Themes, { getTheme } from '../../constants/Themes';
import systemsForUser from '../../utils/systemsForUser';
import userFulfillmentColor from "../../utils/userFulfillmentColor";

const bgImage = {};//{backgroundImage: "url("+image+")"};



class Sidebar extends Component{
    constructor(props){
        super(props);
        this.state = {
            openAvatar: false,
            isWindows: (navigator.platform.indexOf('Win') > -1 ),
            width: window.innerWidth
        };

    }
    // verifies if routeName is the one active (in browser input)
    activeRoute(routeName) {
        if(!routeName) return '';
        return this.props.location.pathname.indexOf(routeName.replace(/\/:[^/]*/g, "")) > -1 ? 'active' : '';
    }
    // if the windows width changes CSS has to make some changes
    // this functions tell react what width is the window
    updateDimensions=()=>{
        this.setState({width:window.innerWidth});
    };
    componentDidMount() {
        this.updateDimensions();
        // add event listener for windows resize

        window.addEventListener("resize", this.updateDimensions);
        /*
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && this.refs.sidebarWrapper ) {
            Ps.initialize(this.refs.sidebarWrapper, { wheelSpeed: 2, suppressScrollX: true });
        }
        */
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    componentDidUpdate(){
        /*
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            setTimeout(() => { Ps.update(this.refs.sidebarWrapper) }, 350);
        }
        */
    }

    // function that creates perfect scroll bar for windows users (it creates a scrollbar that looks like the one from apple devices)
    /*isMac(){
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
    */

    renderSystemOption = ( option, selected=false, withHandle=false )=>{
        return (
            <a
                key={option? option.name : 'default'}
                className={"simple-text logo-normal " + (selected?'':'option')}
                data-system={option? option.name : ''}
                href='/'
                onClick={ selected?
                    this.toggleSystemOptions:
                    this.changeSystem
                }
            >
                <img src={ option? option.logo : Themes[0].logo } alt="The Grand Lounge Elite" />
                { withHandle?
                    <i className='caret'/>:null
                }
            </a>
        );
    };

    toggleSystemOptions = ( open )=>{

        if( open.preventDefault ) open.preventDefault();

        const isOpen = open === false || open === true ? open : !this.state.sectionDropdownOpen;
        this.setState( {sectionDropdownOpen: isOpen} );
    };

    changeSystem = ( e )=>{

        this.toggleSystemOptions( false );
        e.preventDefault();

        const system = e.currentTarget.dataset.system;
        if( system ) {

            this.props.onSystemChange(system);
            const systemInitialRoute = routesForUser( this.props.me, system )[0];

            if( systemInitialRoute )
                this.props.history.push( systemInitialRoute.path );
        }
    };

    meClick = (e)=>{
        e.preventDefault();
        this.props.onMeClick();
    };

    openMenu = ( e )=>{
        e.preventDefault();
        const st = e.currentTarget.dataset.state;
        this.setState( { [st]:!this.state[st] } );
    };

    render(){

        let employee = null;
        if( this.props.me )
            employee = this.props.me.employee;

        const systems = _.filter( Themes, (sys)=> systemsForUser( this.props.me ).indexOf( sys.name ) !== -1  );

        const actualSystem = _.find( systems, ( sys )=> sys.name === this.props.system );

        return (

            <div className={"sidebar " + (this.state.sectionDropdownOpen?'open-sidebar-plus':'')} data-color={ getTheme(this.props.system).sidebarColor } data-image={image}>

                <div className="sidebar-background" style={bgImage} />
                <div className={"logo " + (this.state.sectionDropdownOpen?'open':'')}>
                    <a href='/' className="simple-text logo-mini">
                        TGLE
                    </a>

                    {this.renderSystemOption( actualSystem, true, systems.length > 1 )}

                    {systems.map((sys)=>
                        //Don't render selected system in options, it's already the displayed logo
                        !actualSystem || sys.name !== actualSystem.name?
                            this.renderSystemOption( sys ):
                            null
                    )}

                </div>
                <div className="sidebar-wrapper" ref="sidebarWrapper">
                    <div className="user">
                        <div className="photo" style={{borderColor: this.props.me && this.props.me.employee?
                                userFulfillmentColor(  this.props.me.employee.fulfillmentScore ):
                                "rgba(255,255,255,0.3)"
                        }}>
                            <img src={this.props.avatar} alt="Avatar"/>
                        </div>
                        <div className="info">
                            <a href='/' onClick={this.meClick} >
                                <span>
                                    { !this.props.me? "Cargando...":
                                        !employee? this.props.me.username:
                                            employee.name }
                                </span>
                            </a>
                        </div>
                    </div>

                    <ul className="nav">
                        {/* If we are on responsive, we want both links from navbar and sidebar
                            to appear in sidebar, so we render here HeaderLinks */}
                        { this.state.width <= 992 ? (<HeaderLinks />):null }
                        {/*
                            here we render the links in the sidebar
                            if the link is simple, we make a simple link, if not,
                            we have to create a collapsible group,
                            with the speciffic parent button and with it's children which are the links
                        */}
                        {
                            this.props.routes.map((prop,key) => {
                                if(prop.collapse){
                                    return (
                                        <li className={this.activeRoute(prop.path)} key={key}>
                                            <a href='/' data-state={prop.state} onClick={this.openMenu }>
                                                <i className={prop.icon} />
                                                <p>{prop.smallName? prop.smallName : prop.name}
                                                   <b className={this.state[prop.state] ? "caret rotate-180":"caret"} />
                                                </p>
                                            </a>
                                            <Collapse in={this.state[prop.state]}>
                                                <ul className="nav">
                                                    {
                                                        prop.views.map((prop,key) => {

                                                            return (
                                                                <li className={this.activeRoute(prop.path)} key={key}>
                                                                    <NavLink to={prop.path.replace(/\/:[^/]*/g, "")} className="nav-link" activeClassName="active">
                                                                        <span className="sidebar-mini">{prop.mini}</span>
                                                                        <span className="sidebar-normal">{prop.smallName? prop.smallName : prop.name}</span>
                                                                    </NavLink>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </Collapse>
                                        </li>
                                    )
                                } else {
                                    if(prop.redirect || prop.hidden){
                                        return null;
                                    }
                                    else{
                                        return (
                                            <li className={this.activeRoute(prop.path)} key={key}>
                                                <NavLink to={prop.path.replace(/\/:[^/]*/g, "")} className="nav-link" activeClassName="active">
                                                    <i className={prop.icon} />
                                                    <p>{prop.smallName? prop.smallName : prop.name}</p>
                                                </NavLink>
                                            </li>
                                        );
                                    }
                                }
                            })
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => bindActionCreators({ onSystemChange: changeSystem }, dispatch );

const mapStateToProps = ({api:{me}, system}) => ({me, system});

export default connect( mapStateToProps, mapDispatchToProps )(Sidebar);
